<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer008">
<p class="Chapter-title-one-line"><span class="Chap-title _idGenCharOverride-1">Acknowledgments</span></p>
</div>
<p> </p>
<p> </p>
<div class="_idGenObjectStyleOverride-1" id="_idContainer010">
<p class="Text-body ParaOverride-4"><span class="Text-body CharOverride-10">Thanks to all the folks at Haymarket Books. Anthony Arnove has always offered encouragement and is available for advice around the clock. Julie Fain oversaw the entire project with diligence, good humor, and </span><span class="text-body-no-indent _idGenCharOverride-1">heroic</span><span class="Text-body CharOverride-10"> patience. Dao Tran’s careful reading and insightful comments brought political clarity when it was lacking in the original manuscript. Tristin Adie’s meticulous reading of the final manuscript has spared me much embarrassment. And Ahmed Shawki’s editorial work was invaluable in giving this book its final form. To each of them, I express my heartfelt gratitude. Any remaining errors are, of course, my own.</span></p>
<p class="Text-body"><span class="Text-body CharOverride-10">In addition, I am very fortunate to be surrounded by an incredible team of coworkers and collaborators in Chicago: Alan Maass, Marlene Martin, Paul D’Amato, Lance Selfa, Lee Sustar, Elizabeth Schulte, Nicole Colson, Joel Geier, David Whitehouse, Sherry Wolf, Bill Roberts, Eric Ruder, Adam Turl, and Sarah Macaraeg. </span></p>
<p class="Text-body"><span class="Text-body CharOverride-10">This book owes an enormous debt to the many radicals and union militants who have dedicated their lives to building the class struggle in all its elements. Their experiences and politics point the way forward for those of us today urgently seeking a new path for the working-class movement. We truly stand on the shoulders of giants.</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer011">
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?5f89b5d6